import clsx from 'clsx'
import React, { useCallback, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { getFeaturedShow, getPastShows, getCategories } from 'redux/slices/shows'
import { fetchShows } from 'redux/slices/shows/thunks'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import FeaturedShow from 'components/root/FeaturedShow/FeaturedShow'
import Footer from 'components/common/Footer/Footer'
import { useStyles } from './styles'
import Shows from 'components/root/Shows/Shows'
import { Show } from 'data/Show'

enum ShowsSectionTitle {
    MUSIC = 'Upcoming Events',
    BOOK = 'Upcoming Book Tours',
}

const Homepage: React.FC = () => {
    const dispatch = useDispatch()
    const show = useSelector(getFeaturedShow)
    const classes = useStyles({ image: show?.posterImg })
    const pastShows = useSelector(getPastShows)
    const categories = useSelector(getCategories)
    const history = useHistory()

    const musicShows = categories['MUSIC']
    const bookTours = categories['BOOK']

    useEffect(() => {
        dispatch(fetchShows())
    }, [dispatch])

    const goToSetPageOrSeries = useCallback(
        (show: Show) => {
            if (show) {
                if (show.seriesId) {
                    history.push(`/hub/${show.seriesId}`)
                } else {
                    history.push(show.path)
                }
            }
        },
        [history],
    )

    return (
        <div className={classes.homepage}>
            <Helmet>
                <title>Novel - Premium Livestreams</title>
                <meta
                    name="description"
                    content="Livestream and entertainment platform building digital communities around inspired content. Join the experience now."
                />
            </Helmet>
            <div className={classes.content}>
                {show && (
                    <section className={classes.section}>
                        <FeaturedShow show={show} onClick={goToSetPageOrSeries} />
                    </section>
                )}

                {musicShows && (
                    <Shows
                        onItemClick={goToSetPageOrSeries}
                        items={musicShows}
                        title={ShowsSectionTitle['MUSIC']}
                        className={clsx(classes.section, classes.showCardSection)}
                    />
                )}

                {bookTours && (
                    <Shows
                        onItemClick={goToSetPageOrSeries}
                        items={bookTours}
                        title={ShowsSectionTitle['BOOK']}
                        className={clsx(classes.section, classes.showCardSection)}
                    />
                )}

                {!!pastShows.length && (
                    <Shows
                        onItemClick={goToSetPageOrSeries}
                        items={pastShows}
                        title="Past shows"
                        className={clsx(classes.section, classes.showCardSection)}
                    />
                )}
            </div>

            <div className={classes.bg}>
                <div className={classes.img} />
            </div>
            <Footer />
        </div>
    )
}

export default Homepage
